import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import { AuthProvider } from "@/portal/AuthContext";
import ProtectedRoute from "@/portal/ProtectedRoute";
import MarketingLayout from "@/components/MarketingLayout";
import Login from "@/pages/portal/Login";
import PortalLayout from "@/pages/portal/PortalLayout";
import PublicApply from "@/pages/portal/PublicApply";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/apply" element={<PublicApply />} />
            <Route path="/apply/:refCode" element={<PublicApply />} />
            <Route
              path="/portal/*"
              element={
                <ProtectedRoute>
                  <PortalLayout />
                </ProtectedRoute>
              }
            />
            <Route path="/*" element={<MarketingLayout />} />
          </Routes>
          <Toaster position="top-center" richColors closeButton />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
